import commissionSchedulesSaga from 'Agent/Commissions/sagas/commissionSchedulesSaga';
import commissionsSaga from 'Agent/Commissions/sagas/commissionsSaga';
import {all} from 'redux-saga/effects';

export default function*() {
  yield all([commissionSchedulesSaga(), commissionsSaga()]);
}
